import { codeSplit } from "bernie-core";
import { FlexComponentMap, ImportReactComponent } from "./typings";

export const flexComponentMap: FlexComponentMap = (new Map() as FlexComponentMap)
  .set("region", {
    webpackChunkName: "flex-SimpleContainer",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-SimpleContainer" */ "components/flexComponents/SimpleContainer/SimpleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_centered-content-container", {
    webpackChunkName: "flex-CenteredContentRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CenteredContentRegion" */ "components/flexComponents/CenteredContentRegion/CenteredContentRegion"
        ) as any
    ),
  })
  .set("region_storefront-wizard", {
    webpackChunkName: "flex-StorefrontWizard",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-StorefrontWizard" */ "components/flexComponents/WizardPWARegions/StorefrontWizardRegion/StorefrontWizardRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-bex", {
    webpackChunkName: "flex-StorefrontWizardBEX",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-StorefrontWizardBEX" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionBEX/StorefrontWizardRegionBEX"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-taap", {
    webpackChunkName: "flex-StorefrontWizardTAAP",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-StorefrontWizardTAAP" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionTAAP/StorefrontWizardRegionTAAP"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-comet", {
    webpackChunkName: "flex-StorefrontWizardCOMET",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-StorefrontWizardCOMET" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionCOMET/StorefrontWizardRegionCOMET"
        ) as ImportReactComponent
    ),
  })
  .set("region_centralized-wizard", {
    webpackChunkName: "flex-CentralizedWizard",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CentralizedWizard" */ "components/flexComponents/WizardPWARegions/CentralizedWizardRegion/CentralizedWizardRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_wizard-hotwire", {
    webpackChunkName: "flex-WizardRegionHotwire",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardRegionHotwire" */ "components/flexComponents/WizardPWARegions/WizardRegionHotwire/WizardRegionHotwire"
        ) as ImportReactComponent
    ),
  })
  .set("region_cta-carousel", {
    webpackChunkName: "flex-CTACarouselRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CTACarouselRegion" */ "components/flexComponents/CTACarouselRegion/CTACarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_lob-carousel", {
    webpackChunkName: "flex-CTACarouselRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CTACarouselRegion" */ "components/flexComponents/CTACarouselRegion/CTACarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_grid-merch-container", {
    webpackChunkName: "flex-CTACarouselRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CTACarouselRegion" */ "components/flexComponents/CTACarouselRegion/CTACarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_mobile-confidence-messages-carousel", {
    webpackChunkName: "flex-MobileConfidenceMessagesCarousel",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MobileConfidenceMessagesCarousel" */ "components/flexComponents/MobileConfidenceMessagesCarouselRegion/MobileConfidenceMessagesCarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_wizard-background-image-or-color", {
    webpackChunkName: "flex-WizardBackgroundImageOrColorRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardBackgroundImageOrColorRegion" */ "components/flexComponents/WizardBackgroundImageOrColorRegion/WizardBackgroundImageOrColorRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_multi-column", {
    webpackChunkName: "flex-MultiColumn",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MultiColumn" */ "components/flexComponents/MultiColumnContainer/MultiColumnContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_affinity-full-width", {
    webpackChunkName: "flex-AffinityRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-AffinityRegion" */ "src/components/flexComponents/AffinityRegion/AffinityRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_affinity-image", {
    webpackChunkName: "flex-AffinityRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-AffinityRegion" */ "src/components/flexComponents/AffinityRegion/AffinityRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_affinity-container", {
    webpackChunkName: "flex-AffinityRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-AffinityRegion" */ "src/components/flexComponents/AffinityRegion/AffinityRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_two-buttons", {
    webpackChunkName: "flex-TwoButtons",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TwoButtons" */ "src/components/flexComponents/TwoButtonsRegion/TwoButtonsRegion"
        ) as ImportReactComponent
    ),
  })
  .set("breadcrumbs", {
    webpackChunkName: "flex-Breadcrumbs",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Breadcrumbs" */ "components/flexComponents/Breadcrumbs/Breadcrumbs"
        ) as ImportReactComponent
    ),
  })
  .set("call-to-action", {
    webpackChunkName: "flex-CallToAction",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CallToAction" */ "components/flexComponents/CallToAction/CallToAction"
        ) as ImportReactComponent
    ),
  })
  .set("check-prices", {
    webpackChunkName: "flex-CheckPrices",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CheckPrices" */ "components/flexComponents/CheckPrices/CheckPrices"
        ) as ImportReactComponent
    ),
  })
  .set("cross-lob-links", {
    webpackChunkName: "flex-CrossLOBLinks",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CrossLOBLinks" */ "components/flexComponents/CrossLOBLinks/CrossLOBLinks"
        ) as ImportReactComponent
    ),
  })
  .set("destination-attractions", {
    webpackChunkName: "flex-DestinationAttractions",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationAttractions" */ "components/flexComponents/DestinationAttractions/DestinationAttractions"
        ) as ImportReactComponent
    ),
  })
  .set("destination-description", {
    webpackChunkName: "flex-DestinationDescription",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationDescription" */ "components/flexComponents/DestinationDescription/DestinationDescription"
        ) as ImportReactComponent
    ),
  })
  .set("destination-discovery-map", {
    webpackChunkName: "flex-DestinationDiscoveryMap",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationDiscoveryMap" */ "components/flexComponents/DestinationDiscoveryMap/DestinationDiscoveryMap"
        ) as ImportReactComponent
    ),
  })
  .set("destination-hero", {
    webpackChunkName: "flex-DestinationHero",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationHero" */ "components/flexComponents/DestinationHero/DestinationHero"
        ) as ImportReactComponent
    ),
  })
  .set("destination-neighborhoods", {
    webpackChunkName: "flex-DestinationNeighborhoods",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationNeighborhoods" */ "components/flexComponents/DestinationNeighborhoods/DestinationNeighborhoods"
        ) as ImportReactComponent
    ),
  })
  .set("destination-suggestions", {
    webpackChunkName: "flex-DestinationSuggestions",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationSuggestions" */ "components/flexComponents/DestinationSuggestions/DestinationSuggestions"
        ) as ImportReactComponent
    ),
  })
  .set("destination-user-reviews", {
    webpackChunkName: "flex-DestinationUserReviews",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationUserReviews" */ "components/flexComponents/DestinationUserReviews/DestinationUserReviews"
        ) as ImportReactComponent
    ),
  })
  .set("editorial", {
    webpackChunkName: "flex-Editorial",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Editorial" */ "components/flexComponents/Content/Content"
        ) as ImportReactComponent
    ),
  })
  .set("dynamic-vendor-content", {
    webpackChunkName: "flex-Editorial",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Editorial" */ "components/flexComponents/Content/Content"
        ) as ImportReactComponent
    ),
  })
  .set("frequently-asked-questions", {
    webpackChunkName: "flex-Faq",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Faq" */ "components/flexComponents/Faq/Faq") as ImportReactComponent
    ),
  })
  .set("hotel-recent-reviews", {
    webpackChunkName: "flex-HotelRecentReviews",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelRecentReviews" */ "components/flexComponents/HotelRecentReviews/HotelRecentReviews"
        ) as ImportReactComponent
    ),
  })
  .set("hotel-recent-reviews_thumbnail-image-left-card", {
    webpackChunkName: "flex-HotelRecentReviewsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelRecentReviewsView" */ "components/flexComponents/HotelRecentReviews/views/HotelRecentReviewsView"
        ) as ImportReactComponent
    ),
  })
  .set("hotel-recent-reviews_header-image-card", {
    webpackChunkName: "flex-HotelRecentReviewsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelRecentReviewsView" */ "components/flexComponents/HotelRecentReviews/views/HotelRecentReviewsView"
        ) as ImportReactComponent
    ),
  })
  .set("hotels", {
    webpackChunkName: "flex-Hotels",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-Hotels" */ "components/flexComponents/Hotels/Hotels") as ImportReactComponent
    ),
  })
  .set("hotels_carousel", {
    webpackChunkName: "flex-ViewCarousel",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-ViewCarousel" */ "components/flexComponents/Hotels/views/ViewCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_travellers-loved", {
    webpackChunkName: "flex-TravelersLovedHotels",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TravelersLovedHotels" */ "components/flexComponents/Hotels/views/TravelersLovedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_summarized-hotels", {
    webpackChunkName: "flex-SummarizedHotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-SummarizedHotelsView" */ "src/components/flexComponents/Hotels/views/SummarizedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_summarized-hotels-carousel", {
    webpackChunkName: "flex-SummarizedHotelsCarouselView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-SummarizedHotelsCarouselView" */ "src/components/flexComponents/Hotels/views/SummarizedHotelsCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("jumplinks", {
    webpackChunkName: "flex-Jumplinks",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Jumplinks" */ "components/flexComponents/Jumplinks/Jumplinks"
        ) as ImportReactComponent
    ),
  })
  .set("links", {
    webpackChunkName: "flex-Links",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Links" */ "components/flexComponents/Links/Links") as ImportReactComponent
    ),
  })
  .set("maps", {
    webpackChunkName: "flex-Maps",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-Maps" */ "components/flexComponents/Maps/MapsViews") as ImportReactComponent
    ),
  })
  .set("maps_dynamic", {
    webpackChunkName: "flex-Maps",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-Maps" */ "components/flexComponents/Maps/MapsViews") as ImportReactComponent
    ),
  })
  .set("maps_button", {
    webpackChunkName: "flex-MapButton",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MapButton" */ "components/flexComponents/Maps/views/MapButton"
        ) as ImportReactComponent
    ),
  })
  .set("page-heading", {
    webpackChunkName: "flex-PageHeading",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PageHeading" */ "components/flexComponents/PageHeading/PageHeading"
        ) as ImportReactComponent
    ),
  })
  .set("page-heading_wizard", {
    webpackChunkName: "flex-PageHeadingWizard",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PageHeadingWizard" */ "components/flexComponents/PageHeading/view/PageHeadingWizard"
        ) as ImportReactComponent
    ),
  })
  .set("recently-booked-hotels", {
    webpackChunkName: "flex-RecentlyBookedHotels",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-RecentlyBookedHotels" */ "components/flexComponents/RecentlyBookedHotels/RecentlyBookedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("recently-booked-hotels_thumbnail-image-left-card-carousel", {
    webpackChunkName: "flex-RecentlyBookedHotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-RecentlyBookedHotelsView" */ "components/flexComponents/RecentlyBookedHotels/views/RecentlyBookedHotelsView"
        ) as ImportReactComponent
    ),
  })
  .set("recently-booked-hotels_full-bleed-image-card-carousel", {
    webpackChunkName: "flex-RecentlyBookedHotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-RecentlyBookedHotelsView" */ "components/flexComponents/RecentlyBookedHotels/views/RecentlyBookedHotelsView"
        ) as ImportReactComponent
    ),
  })
  .set("similar-destiations", {
    webpackChunkName: "flex-SimilarDestinations",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-SimilarDestinations" */ "components/flexComponents/SimilarDestinations/SimilarDestinations"
        ) as ImportReactComponent
    ),
  })
  .set("top-cities", {
    webpackChunkName: "flex-TopCities",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TopCities" */ "components/flexComponents/TopCities/TopCities"
        ) as ImportReactComponent
    ),
  })
  .set("trip-cost-estimator", {
    webpackChunkName: "flex-TripCostEstimator",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TripCostEstimator" */ "components/flexComponents/TripCostEstimator/TripCostEstimator"
        ) as ImportReactComponent
    ),
  })
  .set("te-neighborhood", {
    webpackChunkName: "flex-DestinationNeighborhoods",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationNeighborhoods" */ "components/flexComponents/DestinationNeighborhoods/DestinationNeighborhoods"
        ) as ImportReactComponent
    ),
  })
  .set("te-neighborhood_neighborhood_with_dx_hsr", {
    webpackChunkName: "flex-TopNeighborhoods",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TopNeighborhoods" */ "components/flexComponents/DestinationNeighborhoods/views/TopNeighborhoods"
        ) as ImportReactComponent
    ),
  })
  .set("te-similar-destination", {
    webpackChunkName: "flex-SimilarDestinations",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-SimilarDestinations" */ "components/flexComponents/SimilarDestinations/SimilarDestinations"
        ) as ImportReactComponent
    ),
  })
  .set("te-article", {
    webpackChunkName: "flex-VisitorBlogs",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-VisitorBlogs" */ "components/flexComponents/VisitorBlogs/VisitorBlogs"
        ) as ImportReactComponent
    ),
  })
  .set("visitor-blogs", {
    webpackChunkName: "flex-VisitorBlogs",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-VisitorBlogs" */ "components/flexComponents/VisitorBlogs/VisitorBlogs"
        ) as ImportReactComponent
    ),
  })
  .set("wizard", {
    webpackChunkName: "flex-WizardHotelPWAViews",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardHotelPWAViews" */ "components/flexComponents/WizardHotelPWA/WizardHotelPWAViews"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-hotel-pwa", {
    webpackChunkName: "flex-WizardHotelPWAViews",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardHotelPWAViews" */ "components/flexComponents/WizardHotelPWA/WizardHotelPWAViews"
        ) as ImportReactComponent
    ),
  })
  .set("ad", {
    webpackChunkName: "flex-Ad",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Ad" */ "components/flexComponents/Ad/Ad") as ImportReactComponent
    ),
  })
  .set("tab-group", {
    webpackChunkName: "flex-TabGroup",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TabGroup" */ "components/flexComponents/TabGroup/TabGroup"
        ) as ImportReactComponent
    ),
  })
  .set("tab", {
    webpackChunkName: "flex-TabContents",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TabContents" */ "src/components/flexComponents/TabContents/TabContents"
        ) as any
    ),
  })
  .set("link-juice", {
    webpackChunkName: "flex-LinkJuice",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-LinkJuice" */ "components/flexComponents/LinkJuice/LinkJuice"
        ) as ImportReactComponent
    ),
  })
  .set("destination-where-to-stay", {
    webpackChunkName: "flex-DestinationWhereToStay",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationWhereToStay" */ "components/flexComponents/DestinationWhereToStay/DestinationWhereToStay"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-car-pwa", {
    webpackChunkName: "flex-WizardCarPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardCarPWA" */ "components/flexComponents/WizardCarPWA/WizardCarPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-gt-pwa", {
    webpackChunkName: "flex-WizardGTPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardGTPWA" */ "components/flexComponents/WizardCarPWA/WizardCarPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-lx-pwa", {
    webpackChunkName: "flex-WizardLXPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardLXPWA" */ "components/flexComponents/WizardLXPWA/WizardLXPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-thirdPartyPackage-pwa", {
    webpackChunkName: "flex-Wizard3ppPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Wizard3ppPWA" */ "components/flexComponents/Wizard3ppPWA/Wizard3ppPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-externalLinkTab-pwa", {
    webpackChunkName: "flex-WizardExternalLinkTabPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardExternalLinkTabPWA" */ "components/flexComponents/WizardExternalLinkTabPWA/WizardExternalLinkTabPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-cruise-pwa", {
    webpackChunkName: "flex-WizardCruisePWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardCruisePWA" */ "components/flexComponents/WizardCruisePWA/WizardCruisePWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-package-pwa", {
    webpackChunkName: "flex-WizardPackagePWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardPackagePWA" */ "components/flexComponents/WizardPackagePWA/WizardPackagePWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-flight-pwa", {
    webpackChunkName: "flex-WizardFlightPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardFlightPWA" */ "components/flexComponents/WizardFlightPWA/WizardFlightPWA.tsx"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-vr-pwa", {
    webpackChunkName: "flex-WizardVRPWA",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardVRPWA" */ "src/components/flexComponents/WizardVRPWA/WizardVRPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-hotel-pwa-v2", {
    webpackChunkName: "flex-WizardHotelPWAv2",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-WizardHotelPWAv2" */ "components/flexComponents/WizardHotelPWAv2/WizardHotelPWAv2"
        ) as ImportReactComponent
    ),
  })
  .set("native-tile-showcase", {
    webpackChunkName: "flex-NativeTileShowcase",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NativeTileShowcase" */ "components/flexComponents/NativeTileShowcase/NativeTileShowcase"
        ) as ImportReactComponent
    ),
  })
  .set("native-marquee-tile", {
    webpackChunkName: "flex-NativeMarqueeTile",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NativeMarqueeTile" */ "components/flexComponents/NativeMarqueeTile/NativeMarqueeTile"
        ) as ImportReactComponent
    ),
  })
  .set("region_theme-selector", {
    webpackChunkName: "flex-ThemeSelectorRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-ThemeSelectorRegion" */ "components/flexComponents/ThemeSelectorRegion/ThemeSelectorRegion"
        ) as any
    ),
  })
  .set("region_destination-selector", {
    webpackChunkName: "flex-DestinationSelectorRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationSelectorRegion" */ "components/flexComponents/DestinationSelectorRegion/DestinationSelectorRegion"
        ) as any
    ),
  })
  .set("destination-video", {
    webpackChunkName: "flex-DestinationVideo",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationVideo" */ "components/flexComponents/DestinationVideo/DestinationVideo"
        ) as any
    ),
  })
  .set("recently-viewed-hotels", {
    webpackChunkName: "flex-RecentlyViewedHotels",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-RecentlyViewedHotels" */ "components/flexComponents/RecentlyViewedHotels/RecentlyViewedHotels"
        ) as any
    ),
  })
  .set("trip-attach-qualification", {
    webpackChunkName: "flex-TripAttachQualification",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TripAttachQualification" */ "components/flexComponents/TripAttachQualification/TripAttachQualification"
        ) as any
    ),
  })
  .set("destination-cross-link", {
    webpackChunkName: "flex-DestinationCrossLink",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationCrossLink" */ "components/flexComponents/DestinationCrossLink/DestinationCrossLink"
        ) as any
    ),
  })
  .set("merch-campaigns", {
    webpackChunkName: "flex-MerchCampaign",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MerchCampaign" */ "src/components/flexComponents/MerchCampaign/MerchCampaign"
        ) as any
    ),
  })
  .set("universal-link", {
    webpackChunkName: "flex-UniversalLink",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-UniversalLink" */ "components/flexComponents/UniversalLink/UniversalLink"
        ) as any
    ),
  })
  .set("recently-viewed", {
    webpackChunkName: "flex-RecentlyViewedWrapper",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-RecentlyViewedWrapper" */ "components/flexComponents/RecentlyViewedWrapper/RecentlyViewedWrapper"
        ) as any
    ),
  })
  .set("property-filters", {
    webpackChunkName: "flex-PropertyFilters",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyFilters" */ "components/flexComponents/PropertyFilters/PropertyFilters"
        ) as any
    ),
  })
  .set("property-filters_pills", {
    webpackChunkName: "flex-PropertyFiltersView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyFiltersView" */ "components/flexComponents/PropertyFilters/views/PropertyFiltersPills"
        ) as any
    ),
  })
  .set("packaging", {
    webpackChunkName: "flex-Packages",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Packages" */ "components/flexComponents/Packages/Packages") as any
    ),
  })
  .set("babaille-booking-cancellation", {
    webpackChunkName: "flex-BabailleBookingCancellation",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-BabailleBookingCancellation" */ "components/flexComponents/BabailleBookingCancellation/BabailleBookingCancellation"
        ) as any
    ),
  })
  .set("babaille-booking-cancellation-terms", {
    webpackChunkName: "flex-BabailleBookingCancellationTerms",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-BabailleBookingCancellationTerms" */ "components/flexComponents/BabailleBookingCancellationTerms/BabailleBookingCancellationTerms"
        ) as any
    ),
  })
  .set("property-gallery", {
    webpackChunkName: "flex-PropertyGallery",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyGallery" */ "components/flexComponents/PropertyGallery/PropertyGallery"
        ) as ImportReactComponent
    ),
  })
  .set("property-book-by-phone", {
    webpackChunkName: "flex-PropertyBookByPhone",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyBookByPhone" */ "components/flexComponents/PropertyBookByPhone/PropertyBookByPhone"
        ) as ImportReactComponent
    ),
  })
  .set("property-summary", {
    webpackChunkName: "flex-PropertySummary",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertySummary" */ "components/flexComponents/PropertySummary/PropertySummary"
        ) as ImportReactComponent
    ),
  })
  .set("property-whats-around", {
    webpackChunkName: "flex-PropertyWhatsAround",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyWhatsAround" */ "components/flexComponents/PropertyWhatsAround/PropertyWhatsAround"
        ) as ImportReactComponent
    ),
  })
  .set("property-filter-pills", {
    webpackChunkName: "flex-PropertyPillFilters",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyPillFilters" */ "components/flexComponents/PropertyPillFilters/PropertyPillFilters"
        ) as ImportReactComponent
    ),
    dynamicRender: true,
  })
  .set("property-amenity-description", {
    webpackChunkName: "flex-PropertyAmenityDescription",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyAmenityDescription" */ "components/flexComponents/PropertyAmenityDescription/PropertyAmenityDescription"
        ) as ImportReactComponent
    ),
  })
  .set("property-faq", {
    webpackChunkName: "flex-PropertyFaq",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyFaq" */ "components/flexComponents/PropertyFaq/PropertyFaq"
        ) as ImportReactComponent
    ),
  })
  .set("property-similar-properties", {
    webpackChunkName: "flex-PropertySimilarProperties",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertySimilarProperties" */ "components/flexComponents/PropertySimilarProperties/PropertySimilarProperties"
        ) as ImportReactComponent
    ),
    dynamicRender: true,
  })
  .set("property-navigation-bar", {
    webpackChunkName: "flex-PropertyNavigationBar",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyNavigationBar" */ "components/flexComponents/PropertyNavigationBar/PropertyNavigationBar"
        ) as ImportReactComponent
    ),
  })
  .set("property-policies", {
    webpackChunkName: "flex-PropertyPolicies",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyPolicies" */ "components/flexComponents/PropertyPolicies/PropertyPolicies"
        ) as ImportReactComponent
    ),
  })
  .set("property-about-this", {
    webpackChunkName: "flex-PropertyAboutThis",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyAboutThis" */ "components/flexComponents/PropertyAboutThis/PropertyAboutThis"
        ) as ImportReactComponent
    ),
  })
  .set("property-important-info", {
    webpackChunkName: "flex-PropertyImportantInfo",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyImportantInfo" */ "components/flexComponents/PropertyImportantInfo/PropertyImportantInfo"
        ) as ImportReactComponent
    ),
  })
  .set("property-offers", {
    webpackChunkName: "flex-PropertyOffers",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyOffers" */ "components/flexComponents/PropertyOffers/PropertyOffers"
        ) as ImportReactComponent
    ),
    dynamicRender: true,
  })
  .set("property-reviews", {
    webpackChunkName: "flex-PropertyReviewsWrapper",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyReviewsWrapper" */ "components/flexComponents/PropertyReviewsWrapper/PropertyReviewsWrapper"
        ) as ImportReactComponent
    ),
    dynamicRender: true,
  })
  .set("property-reviews-headline", {
    webpackChunkName: "flex-PropertyReviewsHeadlineWrapper",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyReviewsHeadlineWrapper" */ "components/flexComponents/PropertyReviewsHeadline/PropertyReviewsHeadlineWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("property-hero-image", {
    webpackChunkName: "flex-PropertyHeroImageWrapper",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertyHeroImageWrapper" */ "components/flexComponents/PropertyHeroImage/PropertyHeroImageWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("destination-nearest", {
    webpackChunkName: "flex-DestinationNearest",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-DestinationNearest" */ "components/flexComponents/DestinationNearest/DestinationNearest"
        ) as any
    ),
  })
  .set("deals", {
    webpackChunkName: "flex-Deals",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Deals" */ "components/flexComponents/Deals/Deals") as any
    ),
  })
  .set("separator", {
    webpackChunkName: "flex-Separator",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-Separator" */ "components/flexComponents/Separator/Separator"
        ) as ImportReactComponent
    ),
  })
  .set("region_native-ad-container", {
    webpackChunkName: "flex-NativeAdContainerRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NativeAdContainerRegion" */ "components/flexComponents/NativeAdContainerRegion/NativeAdContainerRegion"
        ) as any
    ),
  })
  .set("loyalty-acquisition-banner", {
    webpackChunkName: "flex-LoyaltyAcquisitionBanner",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-LoyaltyAcquisitionBanner" */ "components/flexComponents/LoyaltyAcquisitionBanner/LoyaltyAcquisitionBanner"
        ) as any
    ),
  })
  .set("trips-overview-important", {
    webpackChunkName: "flex-TripsOverviewImportant",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TripsOverviewImportant" */ "components/flexComponents/TripsOverviewImportant/TripsOverviewImportantWrapper"
        ) as any
    ),
  })
  .set("hotels_image-top", {
    webpackChunkName: "flex-HotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelsView" */ "components/flexComponents/Hotels/views/HotelsViews/HotelsViews"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_image-left-small", {
    webpackChunkName: "flex-HotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelsView" */ "components/flexComponents/Hotels/views/HotelsViews/HotelsViews"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_image-left-large", {
    webpackChunkName: "flex-HotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelsView" */ "components/flexComponents/Hotels/views/HotelsViews/HotelsViews"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_image-half", {
    webpackChunkName: "flex-HotelsView",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotelsView" */ "components/flexComponents/Hotels/views/HotelsViews/HotelsViews"
        ) as ImportReactComponent
    ),
  })
  .set("global-sitemap", {
    webpackChunkName: "flex-GlobalSiteMaps",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-GlobalSiteMaps" */ "components/flexComponents/GlobalSiteMaps/GlobalSiteMaps"
        ) as any
    ),
  })
  .set("editorial_banner-v2", {
    webpackChunkName: "flex-EditorialBanner",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-EditorialBanner" */ "components/flexComponents/EditorialBanner/EditorialBanner"
        ) as any
    ),
  })
  .set("star-rating-links", {
    webpackChunkName: "flex-StarRatingLinks",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-StarRatingLinks" */ "components/flexComponents/StarRatingLinks/StarRatingLinks"
        ) as any
    ),
  })
  .set("table", {
    webpackChunkName: "flex-TableFlexModule",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TableFlexModule" */ "components/flexComponents/TableFlexModule/TableFlexModule"
        ) as any
    ),
  })
  .set("hotwire-deals", {
    webpackChunkName: "flex-HotwireDeals",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotwireDeals" */
          "components/flexComponents/HotwireDeals/HotwireDeals"
        ) as ImportReactComponent
    ),
  })
  .set("region_native-tile-showcase", {
    webpackChunkName: "flex-NativeTileShowcaseRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NativeTileShowcaseRegion" */ "components/flexComponents/NativeTileShowcaseRegion/NativeTileShowcaseRegion"
        ) as any
    ),
  })
  .set("region_nts-flex-item", {
    webpackChunkName: "flex-NativeTileShowcaseItemRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NativeTileShowcaseItemRegion" */ "components/flexComponents/NativeTileShowcaseItemRegion/NativeTileShowcaseItemRegion"
        ) as any
    ),
  })
  .set("coupons-content", {
    webpackChunkName: "flex-CouponTerms",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-CouponTerms" */ "components/flexComponents/CouponTerms/CouponTerms") as any
    ),
  })
  .set("merch-email-signup", {
    webpackChunkName: "flex-MerchEmailSignUp",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MerchEmailSignUp" */
          "components/flexComponents/MerchEmailSignUp/MerchEmailSignUp.tsx"
        ) as ImportReactComponent
    ),
  })
  .set("region_biased-wizard", {
    webpackChunkName: "flex-BiasedWizardRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-BiasedWizardRegion" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionMeso/StorefrontWizardRegionMeso"
        ) as any
    ),
  })
  .set("cookie-consent-toggle", {
    webpackChunkName: "flex-CookieConsentToggle",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CookieConsentToggle" */ "components/flexComponents/CookieConsentToggle/CookieConsentToggle"
        ) as any
    ),
  })
  .set("airport-address", {
    webpackChunkName: "flex-AirportAddress",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-AirportAddress" */ "components/flexComponents/AirportAddress/AirportAddress"
        ) as any
    ),
  })
  .set("mad-marquee", {
    webpackChunkName: "flex-MadMarquee",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-MadMarquee" */ "components/flexComponents/MadMarquee/MadMarquee") as any
    ),
  })
  .set("travel-advisor", {
    webpackChunkName: "flex-TravelAdvisor",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TravelAdvisor" */ "components/flexComponents/TravelAdvisor/TravelAdvisor"
        ) as any
    ),
  })
  .set("region_auth-container", {
    webpackChunkName: "flex-AuthContainer",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-AuthContainer" */ "components/flexComponents/AuthContainer/AuthContainer"
        ) as any
    ),
  })
  .set("flights-structured-table", {
    webpackChunkName: "flex-FlightsStructuredTable",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-FlightsStructuredTable" */ "components/flexComponents/FlightsStructuredTable/FlightsStructuredTable"
        ) as any
    ),
  })
  .set("coupons", {
    webpackChunkName: "flex-Coupons",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Coupons" */ "src/components/flexComponents/Coupons/Coupons") as any
    ),
  })
  .set("region_meso-collapsible-group", {
    webpackChunkName: "flex-MesoCollapsibleGroupRegion",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MesoCollapsibleGroupRegion" */ "src/components/flexComponents/MesoCollapsibleGroupRegion/MesoCollapsibleGroupRegion"
        ) as any
    ),
  })
  .set("hotwire-marketing-banner", {
    webpackChunkName: "flex-HotwireMarketingBanner",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotwireMarketingBanner" */ "src/components/flexComponents/HotwireMarketingBanner/HotwireMarketingBanner"
        ) as any
    ),
  })
  .set("native-ad", {
    webpackChunkName: "flex-FluidAd",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-FluidAd" */ "components/flexComponents/FluidAd/FluidAd") as any
    ),
  })
  .set("nearby-features", {
    webpackChunkName: "flex-NearbyFeatures",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-NearbyFeatures" */ "components/flexComponents/NearbyFeatures/NearbyFeatures"
        ) as ImportReactComponent
    ),
  })
  .set("customer-notifications-with-dialog", {
    webpackChunkName: "flex-CustomerNotificationsWithDialog",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CustomerNotificationsWithDialog" */ "src/components/flexComponents/CustomerNotificationsWithDialog/CustomerNotificationsWithDialog"
        ) as any
    ),
  })
  .set("meso-marquee-gallery", {
    webpackChunkName: "flex-MesoMarqueeGallery",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MesoMarqueeGallery" */ "components/flexComponents/MesoMarqueeGallery/MesoMarqueeGallery"
        ) as any
    ),
  })
  .set("flights", {
    webpackChunkName: "flex-Flights",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Flights" */ "components/flexComponents/Flights/Flights") as any
    ),
  })
  .set("flights-review", {
    webpackChunkName: "flex-FlightsReview",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-FlightsReview" */ "components/flexComponents/FlightsReview/FlightsReview"
        ) as any
    ),
  })
  .set("hotwire-email-subscription", {
    webpackChunkName: "flex-HotwireEmailSubscription",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotwireEmailSubscription" */ "components/flexComponents/HotwireEmailSubscription/HotwireEmailSubscription"
        ) as any
    ),
  })
  .set("cars", {
    webpackChunkName: "flex-Cars",
    codeSplit: codeSplit(
      () => import(/* webpackChunkName: "flex-Cars" */ "components/flexComponents/Cars/Cars") as any
    ),
  })
  .set("property-search-link", {
    webpackChunkName: "flex-PropertySearchLink",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertySearchLink" */ "components/flexComponents/PropertySearchLink/PropertySearchLink"
        ) as ImportReactComponent
    ),
  })
  .set("property-space-details", {
    webpackChunkName: "flex-PropertySpaceDetails",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PropertySpaceDetails" */ "components/flexComponents/PropertySpaceDetails/PropertySpaceDetails"
        ) as ImportReactComponent
    ),
    dynamicRender: true,
  })
  .set("travel-advisory", {
    webpackChunkName: "flex-TravelAdvisory",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TravelAdvisory" */ "components/flexComponents/TravelAdvisory/TravelAdvisory"
        ) as ImportReactComponent
    ),
  })
  .set("hotwire-affiliate-toast", {
    webpackChunkName: "flex-HotwireAffiliateToast",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-HotwireAffiliateToast" */ "components/flexComponents/HotwireAffiliateToast/HotwireAffiliateToast"
        ) as any
    ),
  })
  .set("price-trend-graph", {
    webpackChunkName: "flex-PriceTrendGraph",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-PriceTrendGraph" */ "components/flexComponents/PriceTrendGraph/PriceTrendGraph"
        ) as any
    ),
  })
  .set("category-activities", {
    webpackChunkName: "flex-CategoryActivities",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-CategoryActivities" */ "components/flexComponents/CategoryActivities/CategoryActivities"
        ) as any
    ),
  })
  .set("trips-overview-hero", {
    webpackChunkName: "flex-TripsOverviewHero",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-TripsOverviewHero" */ "components/flexComponents/TripsOverviewHero/TripsOverviewHeroWrapper"
        ) as any
    ),
  })
  .set("region_toggle", {
    webpackChunkName: "flex-ToggleContainer",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-ToggleContainer" */ "components/flexComponents/ToggleContainer/ToggleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_responsive-toggle", {
    webpackChunkName: "flex-ResponsiveToggleContainer",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-ResponsiveToggleContainer" */ "components/flexComponents/ResponsiveToggleContainer/ResponsiveToggleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("activities-by-category", {
    webpackChunkName: "flex-ActivitiesByCategory",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-ActivitiesByCategory" */ "components/flexComponents/ActivitiesByCategory/ActivitiesByCategory"
        ) as ImportReactComponent
    ),
  })
  .set("meso-ad-configuration-override", {
    webpackChunkName: "flex-MesoAdConfigurationOverride",
    codeSplit: codeSplit(
      () =>
        import(
          /* webpackChunkName: "flex-MesoAdConfigurationOverride" */ "components/flexComponents/MesoAdConfigurationOverride/MesoAdConfigurationOverride"
        ) as any
    ),
  });
